const bom = {
  bomType: "Bom 類型",
  bomCode: "母件編碼",
  bomName: "母件名稱",
  bomModal: "物料規格",
  bomUnit: "計量單位",
  bomVersion: "版本號碼",
  bomVersionDesc: "版本說明",
  bomVersionDate: "版本日期",
  bomStatus: "Bom狀態",
  approvaler: "審核人",
  createDate: "建檔日期",
  creator: "建檔人",
  updateDate: "修改日期",
  updater: "修改人",

  itemLevel: "層級",
  itemCode: "子件編碼",
  itemName: "子件名稱",
  itemModal: "子件規格",
  itemUnit: "計量單位",
  itemBase: "基本數量",
  itemBaseQuantity: "基礎數量",
  itemAttritionRate: "子件損耗率",
  itemUseQuantity: "使用數量",
  itemEffectiveDate: "生效日期",
  itemExpiringDate: "失效日期",
  itemReMark: "備註",
  itemLocators: "定位符1",
  itemExtraRate: '損耗率',

  itemLevelInfo: "第 {{ level }} 層",
  itemReq: "替代料",

  plBaseUnit: "請輸入基本數量",
  plBaseQuantity: "請輸入基礎數量",
  plAttritionRate: "請輸入子件損耗率",
  plUseQuantity: "請輸入使用數量",
  plRemark: "請輸入備註",
  plLocators: "請輸入定位符1",

  importError: '導入失敗',
  bomUpload: '上傳BOM錶',
  bomDetail: 'BOM錶詳情',
  closeTip: "需求清單還未生成，確定要關閉嗎？",
  errTip: "請檢查數據",
  errTipdesc: "至少一個物料的所需數量大於0才可繼續",
  stockNum: "庫存數量",

  reqManage: "需求清單管理",
  preStock: "庫存預出庫數量",
  preInStock: "庫存預入庫數量",
  useStock: "可用庫存數量",
  prePurNum: "需採購數量(常備品為0)",
  prePurNum_1: "需採購數量",
  preOutNum: "預出庫數量(常備品不做預出庫)",
  preOutNum_1: "預出庫數量",
  matchErr: "庫存匹配失敗",
  noSaleOrderOrProduct: "需求清單沒有母件，無法進行生產數量領料",
  bomUsageMatchErr: "BOM匹配失敗，無法進行生產數量領料",
  confirmAdd: "添加需求清單(預出庫單)",
  inventorySucc: "預出庫單:{{number}}已生成，出庫庫位已分配",
  saveTemp: "是否儲存模版？",
  merge: "物料：{{codes}}有重複，其所需數量已相加",
  editBom: "編輯BOM錶",
  addBom: "新增BOM錶",
  materialControlTemplate: "物控需求模版",
  originBom: "主料",
  calcErr: "組合用料數量分配錯誤！",
  calcData: "需滿足：主料的所需數量 + 所有替代料的所需數量之和 = 主料的標準數量總數",
  allocated: "已使用庫存量",
  expandAll: "全部展開",
  collapseAll: "全部折疊",
  parseBonErr: "BOM解析失敗",
  addTip: "以下物料在系統中不存在，是否需要添加這些物料？",
  notItem: "以下物料在系統中不存在，將不會生成需求單數據",
  fileErr: "BOM附件信息獲取失敗",
  facStock: "產線庫存",
  facStockAlloc: "已使用產線庫存量",
  useFactoryCount: "產線庫存用量",
  realStockNum: "在庫庫存數量",
  realPreStock: "在庫庫存預出庫數量",
  realUseStock: "可用在庫庫存數量",
  realAllocated: "已使用在庫庫存量",
  bomNull: "沒有可用的BOM數據源",
  bomNullTip: "至少保證銷售單BOM文件、模版、系統BOM數據三者中有一個",
};

export default bom;
